module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Medium.c9f7f5fb.otf";